import FullTextSearch from "./FullTextSearch"

export default  FullTextSearch;



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/SubHeader/FullTextSearch/index.js